import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "icon icon-loeschen",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 2,
  class: "sr-only"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked'))),
      class: "btn btn-outline-danger"
    }, [
      (!_ctx.iconOnly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.i18nMessage)), 1))
        : _createCommentVNode("", true),
      (_ctx.iconOnly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.iconOnly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.i18nMessage)), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}